import "./departmentCard.css";
import GraphicsRadius from "../graphicsRadius/GraphicRadius";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faGear } from '@fortawesome/free-solid-svg-icons'
const DepartmentCard = (props)=>{

    return(
        <div className={`dc-container ${(props.oneCard == true) ? ("dc-one-container") : ("")}` }>
            <div className="dc-title">
                {props.description}
            </div>
            {typeof props.numberMachines == "number" ? (
                <div className="dc-description">
                <FontAwesomeIcon icon={faGear}></FontAwesomeIcon> Máquinas: {props.numberMachines}
            </div>):(null)}
            
            <div className="dc-graphic">
                <GraphicsRadius legend={"OEE"} signal={"%"} backGraphic={80} data={props.oeeMedium.toFixed(2) ?? 0}></GraphicsRadius>
                <div className="dc-variables-box">
                    <div className="dc-text">
                        Indicadores individuais
                    </div>
                    <div className="dc-variables">
                        <span>
                            <GraphicsRadius size={"sm"} legend={"Performance"}  signal={"%"} backGraphic={100} data={props.performanceMedium.toFixed(2) ?? 0}></GraphicsRadius>
                        </span>
                        <span>
                            <GraphicsRadius size={"sm"}  legend={"Disponibilidade"} signal={"%"} backGraphic={100} data={props.disponibilityMedium.toFixed(2) ?? 0}></GraphicsRadius>
                        </span>
                        <span>
                            <GraphicsRadius size={"sm"} legend={"Qualidade"} signal={"%"} backGraphic={100} data={props.qualityMedium.toFixed(2) ?? 0}></GraphicsRadius>
                        </span>
                    </div>
                    
                </div>
            </div>
            {typeof props.openMachines == "function" ? (
                <div className="dc-button">
                <Button className="full-size" onClick={()=>{props.openMachines()}} disabled={(props.numberMachines > 0) ? false : true}>Máquinas</Button>
                </div>) : (null)}
            
        </div>
    )

}

export default DepartmentCard;